import React, { useEffect, useState } from "react";
//import "./productstable.css";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem, TextField, ThemeProvider, createTheme, responsiveFontSizes } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams } from '@mui/x-data-grid';
import { BrandsService } from "../../service/brands.service";
import { CatalogueService } from "../../service/catalogues.service";
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';

function CatalogueList() {

  const brandsService = new BrandsService();
  const catalogService = new CatalogueService();
  const [selectedSize, setSelectedSize] = useState(1);
  //const [AvailableSizes, setAvailableSizes] = useState<UnitSizes[]>([]);
  const [selectedBrandId, setSelectedBrandId] = React.useState("select");
  const [availableBrands, setAvailableBrands] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(99);
  const [catalogData, setCatalogData] = useState<any[]>([]);

  //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

  const navigate = useNavigate();
  

  const toCatalogDetails = (catIndex: string, action: string) => {
    console.log("cat : ",catIndex , selectedBrandId , catalogData[Number(catIndex)-1])

    navigate('../cataloguedetails',{state:{
      selectedBrandId:selectedBrandId,
      categoryDetails : catalogData[Number(catIndex)-1],
      brandsData: availableBrands 
    }})
  };

  const [open, setOpen] = React.useState(false);



  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 200 },


    { field: 'iconImg', headerName: 'Image', flex: 1, sortable: false, renderCell: (params) => <img src={params.value} width="70" height="70" className="p-2"  /> },
    { field: 'dispName', headerName: 'Category Name', width: 400 },
    {
      field: 'status', headerName: 'Status', flex: 1, 

      renderCell: (params) => {
        return <div>
          {params.value == -1 && (<p style={{ color: "blue" }}>Unknown</p>)
            || params.value == 0 && (<p style={{ color: "red" }}>Deactive</p>)
            || params.value == 1 && (<p style={{ color: "green" }}>Active</p>)
          }

        </div>

      }

    },


    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: { stopPropagation: () => void; }) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellParams> = {};

          api
            .getAllColumns()
            .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
            .forEach(
              (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
            );
        };

        return <div>
          <Button onClick={(e) => toCatalogDetails(params.value, "edit")} > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>

        </div>
      },
      flex: 1
    }

  ];
  //useEffect(() => {
  const submitRequest = (checkApprovalStatus: number) => {

  }//, [selectedEnterprise, selectedStatus]);

  const loadBrandsData = () => {

    brandsService.brands(1).then(data => {
      const res = data.data;
      //const { unit, sizes } = res.data;
      console.log("^^^^^^^^^^^^^^Unit " + res.length);
      // const unitGroups: any = [];
      /*  for (let index = 0; index < res.length; index++) {
          const unitG = res[index].unit;
          const sizesG = res[index].sizes;
          unitGroups.push({ ...sizesG, unit: unitG, });
        }*/
      console.log("grpp ", res);
      setAvailableBrands(res);

    });

  }

  let isLoadDataInit = false;
  useEffect(() => {

 
    if (!isLoadDataInit) {
      isLoadDataInit = true;
      loadBrandsData();
    }

  }, [])

  const loadAllCategories = (brand: Number) => {

    catalogService.catalogues(Number(brand)).then(data => {
      const res = data.data;
      let cnt = 0;
      const peopleWithImages = res.map((person: any, index: any) => {
        cnt = cnt + 1;
        return {
          ...person,
          id: cnt,
          index:cnt,
          action:cnt //person.catId,
        };

      });
      setCatalogData(peopleWithImages)
    });

  }
  const addNew = () => {
    navigate('../cataloguedetails')
  }

  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });

  return (
    <><div className="App card border">
 
      <div className=" col-md-12 row border ml-0">
        <div className="mt-3 mb-3 col-2   text-left">
        <ThemeProvider theme={CustomFontTheme}>
          <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
            className="form-control" name='brandId' defaultValue="select" value={selectedBrandId} 
            onChange={(e: any) => {
              setSelectedBrandId(e.target.value);
              loadAllCategories(e.target.value);
            }}
            >
            <MenuItem style={{fontSize:"small"}}  disabled value="select" key="select">Select</MenuItem>
            {availableBrands.map((_el: any) => <MenuItem style={{fontSize:"small"}} key={_el.brandId} value={_el.brandId}> {_el.brandName}</MenuItem>)}
          </TextField>
          </ThemeProvider>
        </div>
        <div className="col-8 form-group ">

        </div>
 
          <div className="col-2 pt-1 pl-8 text-right mt-3 mb-3 ">
         <Button size="small" style={{color:"green"}} className="form-control text-right" onClick={()=>navigate('../cataloguedetails')} variant="text" 
         startIcon={<AddCircleOutlineTwoToneIcon />}>
            Add New
          </Button>
          </div>
 

      </div>
    </div>
    <div style={{ width: '100%'  }}>
        <DataGrid 
          // table customization start
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              whiteSpace: "break-spaces", fontSize: "13px", fontWeight: "bold",
            },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: "#D0D0D0"
            },
            '& .Mui-odd': {
              textOverflow: "inherit", fontSize: "12px", textAlign: "left"
            },

            '& .Mui-even': {
              backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"
            },

            '& .Mui-cellown': {
              paddingTop: 0, paddingBottom: 0
            },
          }}

          getCellClassName={(params) => 'Mui-cellown'}
          getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
          autoHeight={true}
          getRowHeight={() => 'auto'}

          // table customization
          rows={catalogData}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 25, 50]} />
      </div></>
  


  );
}


export default CatalogueList;
